import MultiLanguageField from './MultiLanguageField';

export default MultiLanguageField;
